/* RipSticks landing — shared behaviour for rsl-* sections.
   Safe to include from several sections: runs once, and re-inits when a
   section is added/reloaded in the theme editor. */
(function () {
  if (window.__rslLoaded) return;
  window.__rslLoaded = true;

  // ── ADD TO CART ── (global so inline onclick="rsAddToCart(id, this)" works)
  window.rsAddToCart = function (variantId, btn) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    var cart = document.querySelector('cart-drawer');
    var sectionIds = (cart && cart.getSectionsToRender)
      ? cart.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ id: variantId, quantity: 1, sections: sectionIds, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          btn.textContent = res.description || 'Unavailable';
          setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2500);
          return;
        }
        btn.textContent = 'Added!';
        if (cart && typeof cart.renderContents === 'function' && res.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-icon-bubble span').forEach(function (el) { el.textContent = c.item_count; });
          });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 2000);
      })
      .catch(function () { btn.disabled = false; btn.textContent = original; });
  };

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  function init(root) {
    root = root || document;

    // FAQ accordion (per list)
    root.querySelectorAll('.faq-list').forEach(function (list) {
      if (!once(list, 'rslFaq')) return;
      list.querySelectorAll('.faq-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.faq-item');
          var open = item.classList.contains('open');
          list.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
          if (!open) item.classList.add('open');
        });
      });
    });

    // Read more (reframe)
    root.querySelectorAll('.rf-read-more').forEach(function (btn) {
      if (!once(btn, 'rslRm')) return;
      btn.addEventListener('click', function () {
        var body = btn.previousElementSibling;
        var open = body.classList.toggle('open');
        btn.classList.toggle('open');
        btn.querySelector('.rf-rm-label').textContent = open ? 'Read Less' : 'Read More';
      });
    });

    // Target tabs (per section)
    root.querySelectorAll('.targets').forEach(function (sec) {
      if (!once(sec, 'rslTabs')) return;
      sec.querySelectorAll('.ttab').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sec.querySelectorAll('.ttab').forEach(function (b) { b.classList.remove('active'); });
          sec.querySelectorAll('.tpanel').forEach(function (p) { p.classList.remove('active'); });
          btn.classList.add('active');
          var panel = sec.querySelector('[data-panel="' + btn.dataset.tab + '"]');
          if (panel) panel.classList.add('active');
        });
      });
    });

    // Video strip
    root.querySelectorAll('.vc-wrap').forEach(function (wrap) {
      if (!once(wrap, 'rslVc')) return;
      var strip = wrap.querySelector('.vc-strip');
      if (!strip) return;
      if ('IntersectionObserver' in window) {
        // Players load only for cards visible inside the strip, and only once the
        // strip itself is near the screen (10.6.26: previously loaded at page open).
        var startStrip = function () {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              var f = e.target.querySelector('iframe');
              if (!f) return;
              if (e.isIntersecting) {
                if (f.dataset.src) { f.src = f.dataset.src; delete f.dataset.src; }
              } else if (f.src) {
                try { f.contentWindow.postMessage('{"method":"pause"}', '*'); } catch (err) {}
              }
            });
          }, { root: strip, threshold: 0.5 });
          strip.querySelectorAll('.vc-card').forEach(function (c) { io.observe(c); });
        };
        var near = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { near.disconnect(); startStrip(); }
        }, { rootMargin: '400px 0px' });
        near.observe(wrap);
      }
      var step = function () { var c = strip.querySelector('.vc-card'); return c ? c.getBoundingClientRect().width + 18 : 280; };
      var prev = wrap.querySelector('.vc-prev'), next = wrap.querySelector('.vc-next');
      if (prev) prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  // Sticky bar (shows after scrolling past a threshold)
  function onScroll() {
    document.querySelectorAll('.rsl .sticky').forEach(function (bar) {
      var px = parseInt(bar.dataset.showAfter || '500', 10);
      bar.classList.toggle('show', window.scrollY > px);
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); onScroll(); });
  } else { init(); onScroll(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); onScroll(); });
})();
